<template>
  <section v-loading="loading">
    <div class="downloadButtonAction">
      <div class="inside">
        <el-button @click="downloadReport" :loading="downloadLoading"
          >DOWNLOAD
          <el-icon><Bottom /></el-icon>
        </el-button>
      </div>
    </div>
    <iframe
      :src="reportData.src"
      width="100%"
      :height="getScreenHeight"
      class="iframe-preview"
    ></iframe>
  </section>
</template>
  <script>
import { mapGetters } from "vuex";
import axios from "axios";
import FileDownloadHelper from "@/mixins/FileDownloadHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  mixins: [FileDownloadHelper],
  computed: {
    ...mapGetters("cases", [
      "getReport",
      "getDownloadReportStatus",
      "getCaseInformation",
    ]),
    ...mapGetters("errors", ["getError"]),
    ...mapGetters("respiratoryFileUpload", ["getFileDownloadUrl"]),
    getScreenHeight() {
      let height = window.innerHeight;
      return height;
    },
    attachmentPath(){
      return this.$route.query.attachment_type ? this.$route.query.attachment_type : "case_attachments"
    }
  },
  data() {
    return {
      reportUrl: "",
      loading: false,
      downloadLoading: false,
      reportData: {
        src: "",
      },
    };
  },
  mounted() {
    this.onPdfView();
  },
  methods: {
    async onPdfView() {
      try {
        this.loading = true;
        this.$store.commit("errors/clear", null, { root: true });
        const downloadUrl = await this.fetchFileDownload();
        this.reportData.src = await this.downloadFileAndPreviewFile(
          downloadUrl,
          false
        );
        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    },
    async fetchFileDownload() {
      try {
        this.loading = true;
        await this.$store.dispatch(
          "respiratoryFileUpload/fetchFileDownloadUrl",
          {
            path: `${this.attachmentPath}/` + this.$route.params.path,
            file_type: "image/png",
          }
        );
        if (this.getFileDownloadUrl && this.getFileDownloadUrl.download_url) {
          return this.getFileDownloadUrl.download_url;
        }
        // this.reportData.src = this.getFileDownloadUrl.download_url;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    async downloadReport() {
      try {
        this.downloadLoading = true;
        await this.$store.dispatch(
          "respiratoryFileUpload/fetchFileDownloadUrl",
          {
            path: `${this.attachmentPath}/`+ this.$route.params.path,
          }
        );
        if (this.getFileDownloadUrl) {
          let url = this.getFileDownloadUrl.download_url;
          axios({
            url: url, //your url
            method: "GET",
            responseType: "blob", // important
          }).then((response) => {
            // create file link in browser's memory
            const href = URL.createObjectURL(response.data);

            // create "a" HTML element with href to file & click
            const link = document.createElement("a");
            link.href = href;
            link.setAttribute("download", `${this.$route.params.path}`); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          });
          // successNotification("Report Downloaded Successfully");
        } else {
          errorNotification("Error in downloading report");
        }
        this.downloadLoading = false;
      } catch (err) {
        this.downloadLoading = false;
      }
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.downloadButtonAction {
  padding: 5px 0;
  background: #d5d5d5;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 10;
  .inside {
    max-width: 900px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    button {
      background: #4bb543;
      color: #ffffff;
      padding: 10px 15px;
      height: auto;
      min-height: auto;
      font-weight: 600;
      svg {
        font-weight: 600;
      }
    }
  }
}
.reportPreview {
  padding-top: 75px;
}
</style>
  
